// Functional programming helpers
import first from 'lodash/fp/first';
import flow from 'lodash/fp/flow';
import partial from 'lodash/fp/partial';
function second(tuple) {
    return tuple[1];
}
function take(amount, array) {
    return array.length < amount ? array.slice() : array.slice(0, amount).slice();
}
export { first, second, flow, partial, take };
//# sourceMappingURL=fp.js.map